import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Toast, ToastDraft } from '../index';

export interface ToastReducerType {
  toastCounter: number;
  toasts: Toast[];
}

export const initialState: ToastReducerType = {
  toastCounter: 0,
  toasts: [],
};

export const toastSlice = createSlice({
  name: 'toastReducer',
  initialState,
  reducers: {
    addToast: (state, action: PayloadAction<ToastDraft>) => {
      const toastDraft = action.payload;

      // Prevent adding duplicate toasts (same message/description/severity)
      const normalize = (s?: string) => s?.trim().toLowerCase() ?? '';
      const isDuplicate = state.toasts.some(
        t =>
          normalize(t.message) === normalize(toastDraft.message) &&
          normalize(t.description) === normalize(toastDraft.description) &&
          !!t.isError === !!toastDraft.isError,
      );
      if (isDuplicate) {
        return; // no-op; keep state as-is
      }

      const newToastCounter = state.toastCounter + 1;
      const newToast: Toast = {
        ...action.payload,
        id: newToastCounter,
      };

      return {
        ...state,
        toastCounter: newToastCounter,
        toasts: [...state.toasts, newToast],
      };
    },
    removeToast: (state, action: PayloadAction<Toast>) => {
      return { ...state, toasts: state.toasts.filter(toast => toast.id !== action.payload.id) };
    },
    resetState: () => initialState,
  },
});

export const { addToast, removeToast } = toastSlice.actions;
export const toastReducer = toastSlice.reducer;
